import { render, staticRenderFns } from "./navBar.vue?vue&type=template&id=531c5c1a&"
import script from "./navBar.vue?vue&type=script&lang=js&"
export * from "./navBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports